import { render, staticRenderFns } from "./ReleaseNotesManagement.vue?vue&type=template&id=42fa1c8e&scoped=true&"
import script from "./ReleaseNotesManagement.vue?vue&type=script&lang=js&"
export * from "./ReleaseNotesManagement.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseNotesManagement.vue?vue&type=style&index=0&id=42fa1c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa1c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/acarmichael/Desktop/DEV/BOSS40-FrontEnd/boss-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VDataTable,VFlex,VLayout})
